import { takeLatest } from 'typed-redux-saga';
import { workerErrorNotifyThunk } from 'utils/sagas';
import { actionReportYieldShekelFetch } from './actions';

export const sagasReportYieldShekel = [
  takeLatest(actionReportYieldShekelFetch.rejected, workerErrorNotifyThunk),
];
